import { Banner } from "./style"


function BannerComponent() {
    return (
        <Banner>
            <div id="pather-div">
                <div id="txt1">
                    <h2>Investimento de tempo no <br/><span>English Std Experience</span>:</h2>
                    <h3>8 meses (160 horas de exposição)</h3>
                </div>
                <div id="txt2">
                    <p>12x <span>R$ 664,00</span></p>
                </div>
            </div>
        </Banner>
    )
}

export default BannerComponent